import { useSelectedOrganization } from './useSelectedOrganization';
import { useEffect, useState } from 'react';
import * as React from 'react';
import { useDidMount } from './useDidMount';

export type LegacyIframeOptions = {
  title: string;
  src: string;
  whiteListedPaths: RegExp[];
  allow?: 'payment';
};

export const useLegacyIframe = (
  options: LegacyIframeOptions
): { loading: boolean; error: boolean; iframe: JSX.Element } => {
  const [isCookieSet, setCookieSet] = useState(false);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const { selectedOrganization } = useSelectedOrganization();

  useDidMount(() => {
    const onMessage = (e: MessageEvent) => {
      const data = e.data;
      const eventName = data.event;
      if (eventName === 'pageLoaded') {
        const path = data.path || '';
        let error = true;
        for (const pathTest of options.whiteListedPaths) {
          if (pathTest.test(path)) {
            error = false;
          }
        }
        setError(error);
      }
    };
    window.addEventListener('message', onMessage, false);
    return () => window.removeEventListener('message', onMessage);
  });

  useEffect(() => {
    if (selectedOrganization?.id) {
      const cookieData = encodeURIComponent(JSON.stringify({ organization_id: selectedOrganization.id }));
      document.cookie = 'fai=' + cookieData + '; Secure; SameSite=None; path=/';
      setCookieSet(true);
    }
  }, [selectedOrganization]);

  const iframe = isCookieSet ? (
    <iframe
      title={options.title}
      onLoad={() => setLoading(false)}
      src={options.src}
      width={'100%'}
      height={'100%'}
      style={{ border: 'none' }}
      allow={options.allow}
    />
  ) : (
    <></>
  );

  return {
    loading,
    error,
    iframe
  };
};
